import $ from 'jquery';

export function loadFlash(){
  $.fn.flashObject = function(){
  	var elementti = $(this);
  	var flashColor = "#e9666e";
  	$(elementti).css("background-color", flashColor );
  	setTimeout( function() {$(elementti).css("background-color", "")}, 200 );
  	setTimeout( function() {$(elementti).css("background-color", flashColor)}, 500 );
  	setTimeout( function() {$(elementti).css("background-color", "")}, 800 );
  }
  $.fn.flashText = function(){
  	var elementti = $(this);
  	var flashColor = "#e9666e";
  	$(elementti).css("color", flashColor );
  	setTimeout( function() {$(elementti).css("color", "")}, 200 );
  	setTimeout( function() {$(elementti).css("color", flashColor)}, 500 );
  	setTimeout( function() {$(elementti).css("color", "")}, 800 );
  }
}
